import { BodySEmphasis, Truncate, type ComponentWrapperType } from "@cerebruminc/cerebellum";
import React, { type FC } from "react";

export const OrgCell: FC<ComponentWrapperType> = ({ cell, row }) => {
	const totalOrganizations = row?._count?.organizations ?? cell?.length ?? 0;
	if (totalOrganizations > 1) {
		return <BodySEmphasis>Multiple organizations</BodySEmphasis>;
	}
	const orgs = cell?.map((org: any) => org.name).join(", ");
	return (
		<BodySEmphasis>
			<Truncate lines={5}>{orgs}</Truncate>
		</BodySEmphasis>
	);
};
